import { action, atom, computed } from 'nanostores';
import type { AugmentedAccount, AugmentedUser, Workspace } from './types';

export interface AuthStore {
  account: AugmentedAccount | null;
  user: AugmentedUser | null;
  workspaces: Workspace[] | null;
}

export const accountStore = atom<AugmentedAccount | null>(null);
export const setAccountStore = action(
  accountStore,
  'setAccountStore',
  (store: typeof accountStore, account: AugmentedAccount) => {
    store.set(account);
    return store.get();
  },
);

export const userStore = atom<AugmentedUser | null>(null);
export const setUserStore = action(userStore, 'setUserStore', (store: typeof userStore, user: AugmentedUser) => {
  store.set(user);
  return store.get();
});

export const workspaceStore = atom<Workspace[] | null>(null);
export const setWorkspaceStore = action(
  workspaceStore,
  'setWorkspaceStore',
  (store: typeof workspaceStore, workspaces: Workspace[]) => {
    store.set(workspaces);
    return store.get();
  },
);

export const authStore = computed([accountStore, userStore, workspaceStore], (account, user, workspaces) => {
  return {
    account,
    user,
    workspaces,
  };
});
